// extracted by mini-css-extract-plugin
module.exports = {"section":"casestudy_section__21ol7","container":"casestudy_container__DXLaj","title":"casestudy_title__2msRU","button":"casestudy_button__2O-lu"};